import cn from 'classnames';
import { removeEmojis } from '@/utils/filterEmojis';
import { normalizeEmail } from '@/utils/normalizeEmail';

const Input = ({ type, name, id, placeholder, onChange, value, hasError }) => {
  const handleChange = (e) => {
    let nextValue = removeEmojis(e.target.value);
    if (type === 'email' || name === 'email' || name === 'email_check') {
      nextValue = normalizeEmail(nextValue);
    }
    e.target.value = nextValue;
    onChange(e);
  };

  return (
    <label htmlFor={name} className="w-full">
      <span className="text-grey-dark">{placeholder}</span>
      <input
        type={type}
        name={name}
        id={name}
        className={cn('input-border-bottom w-full py-10 duration-30', {
          '!border-red': hasError
        })}
        value={value}
        onChange={handleChange}
      />
    </label>
  );
};

export default Input;
